// extracted by mini-css-extract-plugin
module.exports = {"local_display_none":"styles_local_display_none__88ljj","local_display_visible":"styles_local_display_visible__Evovp"};